import { Link } from "react-router-dom";
import PublicBrand from "./PublicBrand";

const FOOTER_GROUPS = [
  ["Platform", [["Product", "/product"], ["Connectors", "/connectors"], ["Use cases", "/use-cases"], ["Pricing", "/pricing"], ["FAQ", "/faq"]]],
  ["Company", [["Resources", "/resources"], ["Contact", "/contact"], ["Trust Center", "/trust"], ["Security", "/security-overview"]]],
  ["Legal", [["Terms", "/terms"], ["Privacy", "/privacy"], ["Refunds", "/refunds"], ["Acceptable Use", "/acceptable-use"], ["Cookies", "/cookies"]]],
];

const DARK_FOCUS = "inline-flex min-h-11 min-w-11 items-center rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-300";

export default function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="overflow-x-hidden border-t border-white/10 bg-[#0b1327] px-6 py-10 text-white lg:px-8">
      <div className="mx-auto max-w-7xl">
        <PublicBrand surface="dark" />
        <div className="mt-12 grid min-w-0 gap-10 sm:grid-cols-3">
          {FOOTER_GROUPS.map(([label, links]) => (
            <nav key={label} aria-label={`${label} footer links`}>
              <h2 className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-orange-300">{label}</h2>
              <ul className="mt-4 grid min-w-0 gap-3 text-sm text-slate-300">
                {links.map(([name, to]) => (
                  <li key={to} className="min-w-0">
                    <Link to={to} className={`${DARK_FOCUS} break-words hover:text-white`}>{name}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} CleanIQ. CleanIQ is provided by Cain Family Insurance LLC.</p>
          <a href="mailto:support@cfinsurance.org" className={`${DARK_FOCUS} break-words hover:text-white`} aria-label="Email CleanIQ support">
            support@cfinsurance.org
          </a>
        </div>
      </div>
    </footer>
  );
}
